import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { CardTitle, Col, Label, Modal, ModalBody, ModalHeader, Row, Input } from "reactstrap"
import Select from "react-select";

const ModalUploadTemplate = ({ show, onSubmit, onCancel, company, reportType, onSubmitImport }) => {
    const [fileUpload, setFileUpload] = useState(null)
    const [selectedType, setSelectedType] = useState(null)

    const onChange = (e) => {
        setSelectedType(e)
    }

    const [isCheckedImport, setIsCheckedImport] = useState(true);
    const [isCheckedUpload, setIsCheckedUpload] = useState(false);

    const handleCheckImportChange = () => {
        setIsCheckedImport(!isCheckedImport);
        setIsCheckedUpload(!isCheckedUpload);
    };
    const handleCheckUploadChange = () => {
        setIsCheckedUpload(!isCheckedUpload);
        setIsCheckedImport(!isCheckedImport);
    };

    useEffect(() => {
        setSelectedType(null)
        setFileUpload(null)
        setIsCheckedImport(true);
        setIsCheckedUpload(false);
    }, [show])

    return (
        <Modal isOpen={show} toggle={onCancel} centered={true} size={'lg'}>
            <ModalHeader>
                <CardTitle>Import Template Report {reportType} - {company?.name}</CardTitle>
            </ModalHeader>
            <ModalBody className="p-3">
                <Row>
                    <Col>
                        <div className="form-check mt-2">
                            <Input
                                type="checkbox"
                                className="form-check-Input"
                                checked={isCheckedImport}
                                id={"checkImport"}
                                onClick={handleCheckImportChange}
                                onChange={(e) => { }}
                            />
                            <Label
                                className="form-check-label ms-1"
                                htmlFor={"checkImport"}>
                                Import Report {reportType}
                            </Label>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col lg={12}>
                        <div className="text-start">
                            <Select
                                isDisabled={isCheckedUpload}
                                value={selectedType}
                                onChange={onChange}
                                placeholder={'Select Company Type'}
                                options={[
                                    { label: "Store", value: "Store" },
                                    { label: "Resto", value: "Resto" },
                                    { label: "Konstruksi", value: "Konstruksi" },
                                    { label: "Hotel", value: "Hotel" },
                                    { label: "Hotel dan Resto", value: "HotelAndResto" },
                                    { label: "Hotel dan Surf", value: "HotelAndSurf" },
                                    { label: "Hotel, Surf dan Store", value: "HotelSurfAndStore" },
                                ]}
                                // className="select2-selection"
                            />
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <div className="form-check mt-2">
                            <Input
                                type="checkbox"
                                className="form-check-Input"
                                checked={isCheckedUpload}
                                id={"checkUpload"}
                                onClick={handleCheckUploadChange}
                                onChange={(e) => { }}
                            />
                            <Label
                                className="form-check-label ms-1"
                                htmlFor={"checkUpload"}>
                                Upload Report {reportType}
                            </Label>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col lg={12}>
                        <div className="text-start">
                            <Input className="form-control" disabled={isCheckedImport} type="file" accept=".xlsx" placeholder={'Select Template XLSX'} onChange={(e) => {
                                if (e.target.files.length > 0) {
                                    setFileUpload(e.target.files[0])
                                }
                                else {
                                    setFileUpload(null)
                                }
                            }} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="text-end mt-3">
                            {
                                isCheckedUpload && <button
                                    type="button"
                                    className="btn btn-success ms-2"
                                    onClick={() => {
                                        onSubmit(fileUpload)
                                    }}
                                    disabled={!fileUpload}>
                                    Upload
                                </button>
                            }
                            {
                                isCheckedImport && <button
                                    type="button"
                                    className="btn btn-success ms-2"
                                    onClick={() => {
                                        onSubmitImport(selectedType.value)
                                    }}
                                    disabled={!selectedType}>
                                    Import
                                </button>
                            }
                            <button
                                type="button"
                                className="btn btn-danger ms-2"
                                onClick={onCancel}>
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </ModalBody>
        </Modal >
    )
}

ModalUploadTemplate.propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    show: PropTypes.any,
    company: PropTypes.any,
}

export default ModalUploadTemplate
